import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';
import { getChartUnit } from 'Util';

const FinancialStatements = ({ data, title, gubn }) => {

  const [options, setOptions] = useState();

  useEffect(() => {
    if (data !== null) {
      const lineColor = ['#1d2a53', '#F15050'];
      const chartType = ['bar', 'line'];

      // 이익률
      if (gubn === 'NP') {
        chartType[0] = 'line';
      }

      const option = {
        animation: false,
        legend: {
          orient: 'horizontal',
          right: 20,
          top: -4,
          textStyle: { fontSize: 10 },
          data: [{
            name: title[0],
            itemStyle: { color: lineColor[0] }
          }, {
            name: title[1],
            itemStyle: { color: lineColor[1] }
          }]
        },
        grid: {
          top: 20,
          right: 5,
          bottom: 0,
          left: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          position: 'bottom',
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitArea: { show: true },
          axisLabel: {
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10
          },
          data: data.x1
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            axisLabel: {
              fontSize: 10
            },
            min: function (value) {
              let cap = value.max - value.min;
              const unit = getChartUnit(cap);

              if (value.min % unit === 0) {
                return value.min;
              } else {
                if (value.min >= 0) {
                  return value.min - (value.min % unit);
                }
              }
            }
          },
          {
            type: 'value',
            position: 'right',
            axisLabel: {
              fontSize: 10
            },
            min: function (value) {
              let cap = value.max - value.min;
              const unit = getChartUnit(cap);

              if (value.min % unit === 0) {
                return value.min;
              } else {
                if (value.min >= 0) {
                  return value.min - (value.min % unit);
                }
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontSize: 10
          }
        },
        series: [
          {
            name: title[0],
            data: data.y1,
            type: chartType[0],
            barWidth: 20,
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[0], width: 2 }
          },
          {
            name: title[1],
            data: data.y2,
            yAxisIndex: 1,
            type: chartType[1],
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[1], width: 2 }
          }
        ]
      }
      setOptions(option);
    }
  }, [data, title, gubn]);

	return (
    <div className="graph" style={{ height: '200px' }}>
      { options &&
        <ECharts option={options} style={{ width: '100%', height: '100%' }} />
      }
    </div>
  );
}

export default FinancialStatements;
